module.exports = __webpack_public_path__ + "img/sidebar_ligue_1_202627.2f93b49c.png";